var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{class:this.classes(
        this.overlay && 'loading-overlay'
    )},[(_vm.active)?_c('div',{staticClass:"ui active text loader"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }